import React from 'react';

const QueueTime = ({ width = '16', height = '16', className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      {...rest}
    >
      <path
        d="M8.00605 13.3402C10.6586 13.3402 12.809 11.1899 12.809 8.5373C12.809 5.88472 10.6586 3.73438 8.00605 3.73438C5.35347 3.73438 3.20312 5.88472 3.20312 8.5373C3.20312 11.1899 5.35347 13.3402 8.00605 13.3402Z"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.8725 6.67188L8.00391 8.54047"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.66797 4.26962L4.26962 2.66797"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7383 2.66797L13.3399 4.26962"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00391 3.73492L8.00391 2.66797"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default QueueTime;
